// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2-rYh","requiredAsterisk":"Info_requiredAsterisk__11OX4"};